import { configureStore } from "@reduxjs/toolkit";

import { abTestReducer } from "Common/abTestUtils/redux";
import { siteConfigSlice } from "Common/Redux/siteConfig";

import { registerBenAdminApi } from "./api";

export const reducerSlices = {
  abTests: abTestReducer,
  [siteConfigSlice.name]: siteConfigSlice.reducer,
  [registerBenAdminApi.reducerPath]: registerBenAdminApi.reducer,
};

export const createStore = (preloadedState) => {
  const store = configureStore({
    reducer: reducerSlices,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(registerBenAdminApi.middleware),
    preloadedState,
  });

  return store;
};
